module.exports = "/_next/static/images/9d4a2e056f990ca02d7f9d8894e6c153-roxinho-single-lg@1x.jpg";